import { atom } from 'recoil';

export const dataPhoneRegis = atom({
  key: 'dataPhoneRegis',
  default: undefined,
});
